import React, { Component } from 'react'
import Datatable from '../../../common/datatable'
import { NavLink } from 'react-router-dom'
import { post } from '../../../../utils/networking'
import { PAGE_SIZE } from '../../../../helpers/constants'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import moment from 'moment';
import $ from 'jquery'
import './style.css'
export default class ListBanner extends Component {

    constructor(props) {
        super(props)

        this.state = {
            request: {
                page: 1,
                pageSize: PAGE_SIZE,
                sort: "desc",
                sortBy: "id",
                keyword: "",
                search: ["title"]
            },
            selectedItems: [],
            data: {
                "total": 0,
                "items": []
            },
            isRender: false,
            isLoaded: false,
            isProccessing: false
        }

    }

    get(param) {
        post('blog/get', param, "partner", result => {
            this.setState({
                data: result,
                isLoaded: true
            })
        })
    }

    delete() {
        confirmAlert({
            title: 'Delete confirm',
            message: 'Are you sure to delete it(s).',
            confirmLabel: 'Confirm',
            cancelLabel: 'Cancel',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        const ids = this.state.selectedItems;
                        if (ids.length == 0) {
                            return
                        }
                        const param = {
                            ids: ids
                        }
                        post('blog/delete', param, "partner", result => {
                            let param = this.state.request
                            this.get(param)
                        })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        })
    }

    onChange(datatable) {
        let param = this.state.request

        param.page = datatable.currentPage;
        param.pageSize = datatable.pageSize
        param.keyword = datatable.keyword
        param.sort = datatable.sort
        param.sortBy = datatable.sortBy

        this.get(param)
    }

    onSelectRow(ids) {
        this.setState({
            selectedItems: [...ids]
        })
    }

    componentDidMount() {
        let param = this.state.request
        this.get(param)
    }

    onActiveBlog(newStatus, id) {
        this.setState({
            isProccessing: true
        })
        let ids = [];
        ids.push(id);
        let param = {
            "status": newStatus,
            "ids": ids
        }

        let newData = this.state.data;
        newData.items.forEach((item) => {
            if (item.id == id) {
                item.status = newStatus
            }
        })
        post('blog/updateStatus', param, "partner", result => {
            this.setState({
                data: newData,
                isProccessing: false
            })
        })
    }

    render() {
        let {
            total,
            items,
        } = this.state.data

        let {
            page,
            pageSize,
            keyword,
            sort,
            sortBy
        } = this.state.request

        let { selectedItems, isLoaded, isProccessing } = this.state

        let renders = [
            {
                name: "id",
                label: "Id",
                align: "left",
                sorting: true,
            },
            {
                name: "title",
                label: "Title",
                align: "left",
                sorting: true,
                searchable: true
            },
            {
                label: "Status",
                align: "left",
                sorting: false,
                searchable: false,
                render: (value) => (value.status == 1) ? <span className={"deactivate"} onClick={this.onActiveBlog.bind(this, 0, value.id)}>{(isProccessing) ? "Wating..." : "Deactivate"}</span> : <span className={"activate"} onClick={this.onActiveBlog.bind(this, 1, value.id)} > {(isProccessing) ? "Wating..." : "Activate"}</span>
            },
            {
                name: "type",
                label: "Type",
                align: "center"
            },
            {
                name: "publicDate",
                label: "Public Date",
                align: "left",
                sorting: true,
                render: (publicDate) => moment(publicDate).format("MM/DD/YYYY")
            },
            {
                name: "id",
                label: "Action",
                align: "center",
                render: (id) => <NavLink to={"/partner/setting/blog-update/" + id}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></NavLink>
            }
        ]

        const datatableOptions = {
            key: "id",
            renders: renders,
            pageSizeList: [10, 20, 50, 100],
            allowViewAll: true,

        }

        const datatableParam = {
            currentPage: page,
            pageSize: pageSize,
            selectedItems: selectedItems,
            keyword: keyword,
            sort: sort,
            sortBy: sortBy
        }

        const dataTableData = {
            total: total,
            rows: items
        }


        return (
            <div>
                {
                    ($(window).width() > 767) ? < div >
                        {
                            (isLoaded) ? <div className="write-blog">
                                <div className="box-header">
                                    <div className="header">
                                        <p>Blogs</p>
                                    </div>
                                    <div className="pull-right">
                                        <NavLink to={"/partner/setting/blog-create"} className="btn btn-primary">New blog</NavLink>
                                        {
                                            (selectedItems.length > 0) ? <button className="btn btn-danger" onClick={() => this.delete()} >Delete</button> : <button className="btn btn-danger" disabled={true} >Delete</button>
                                        }
                                    </div>
                                </div>
                                <div className="box-body">
                                    <Datatable
                                        data={dataTableData}
                                        param={datatableParam}
                                        options={datatableOptions}
                                        onChange={this.onChange.bind(this)}
                                        onSelectRow={this.onSelectRow.bind(this)}
                                    />
                                </div>
                                <div className="box-footer">
                                </div>
                            </div> : <div>
                                    <div className="spinner">
                                        <div className="rect1"></div>
                                        <div className="rect2"></div>
                                        <div className="rect3"></div>
                                        <div className="rect4"></div>
                                        <div className="rect5"></div>
                                    </div>
                                </div>
                        }
                    </div> : <span>The device you are using is too small to perform this feature. Please move to a larger device (exampble PC) to perform.</span>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/partner/blog/list/index.js